import { BackgroundModule } from "./BackgroundModule";
import { BookmarkModule } from "./BookMarkModule";
import { ExternalServicesModule } from "./ExternalServicesModule";
import { HipsModule } from "./HipsModule";
import { ConstellationLayerModule } from "./layers/ConstellationLayer";
import { GridLayerModule } from "./layers/GridLayer";
import { HipparcosCatalogLayerModule } from './layers/HipparcosCatalogLayer';
import { PrettyPictureLayerModule } from "./layers/PrettyPictureLayer";
import { SspDataModule } from "./SspDataModule";
import { ToolModule } from "./ToolModule";
import { TractModule } from "./TractModule";
import { CoordIndicatorModule } from "./CoordIndicatorModule";

export const moduleRegistry = Object.freeze({
  gridLayer: GridLayerModule,
  constellationLayer: ConstellationLayerModule,
  hipparcosCatalogLayer: HipparcosCatalogLayerModule,
  tool: ToolModule,
  bookmark: BookmarkModule,
  sspData: SspDataModule,
  background: BackgroundModule,
  hips: HipsModule,
  prettyPicture: PrettyPictureLayerModule,
  externalService: ExternalServicesModule,
  tract: TractModule,
  coordIndicator: CoordIndicatorModule,
})
